// BootScene — first scene to run. Parses `?seed=N` from the URL, seeds
// the Rng, attaches the dev/test seam (gated), then transitions to
// PreloadScene. No rendering.
//
// Phase-2 D-EM-03: share URLs emit `?seed=<base36>` (lower-32-bits, max 8
// chars). The parser accepts BOTH decimal (`?seed=42` — Phase-1) AND base36
// (`?seed=1ps9wxb` — Phase-2 share-card round-trip). Decimal is recognized
// first to preserve Phase-1 E2E behavior; base36 is the fallback. Falls back
// to seed=1 on null / empty / unparseable input so the boot sequence never
// crashes (T-02-01 ASVS L1: input validation).
//
// The pure parser lives in src/run/parseSeedParam.ts (Ring 0) so it can be
// unit-tested without bootstrapping Phaser; this file just wires it.

import Phaser from 'phaser';
import { Rng } from '../utils/random';
import { TestSeam } from '../debug/TestSeam';
import { parseSeedParam } from '../run/parseSeedParam';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  create(): void {
    TestSeam.setScene('BootScene');

    const params = new URLSearchParams(window.location.search);
    const raw = params.get('seed');
    const seed = parseSeedParam(raw);

    Rng.set(seed);
    // Pass the seed into attach so the seam can mirror it onto __TEST__
    // entirely inside the TEST_MODE gate. Avoids any reference to
    // window.__TEST__ from BootScene proper, which would survive
    // tree-shaking and leak the symbol into production builds (T-01-01).
    TestSeam.attach(this.game, seed);

    this.scene.start('PreloadScene');
  }
}
